import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'

import { type QuoteGenerationOptions } from 'components/quoting/types'
import { Button } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

import CustomizeBenchmarksDropdown from './CustomizeBenchmarksDropdown'

type Props = {
  prospectId: string
  quoteId: string
  canCustomizeBenchmarks?: boolean
  quoteGenerationOptions: QuoteGenerationOptions
  processingQuotePath: string
}

export default function CustomizeBenchmarks ({
  prospectId,
  quoteId,
  canCustomizeBenchmarks,
  quoteGenerationOptions,
  processingQuotePath,
}: Props) {
  const { assign } = useWindowLocation()

  const onSuccess = () => {
    assign(processingQuotePath)
  }

  if (!canCustomizeBenchmarks) {
    return null
  }

  return (
    <CustomizeBenchmarksDropdown
      prospectId={prospectId}
      quoteId={quoteId}
      quoteGenerationOptions={quoteGenerationOptions}
      onSuccess={onSuccess}
      trigger={({ open }) => (
        <Button
          leftIcon={open ? ChevronUpIcon : ChevronDownIcon}
          variant='tertiary'
          size='large'
        >
          Build new custom quote
        </Button>
      )}
    />
  )
}
